import { AuthRepository } from '../repositories/AuthRepository';

export class RemoveAccount {
  constructor(private repository: AuthRepository) {}

  execute(params: RemoveAccountParams): Promise<void> {
    return this.repository.removeAccount(params.otp);
  }
}

export class RemoveAccountParams {
  constructor(public otp: string) {}
}
